import { ICategory } from '@/types/interfaces/navigator';

export default {
	name: 'satpaiBurger',
	value: 'categories.satpaiBurgerTitle',
	title: 'categories.satpaiBurgerTitle',
	position: 10,
	image:
		'https://rahmet.object.pscloud.io/static-files/assets/satpai-group/burger.png',
	payload: {
		search: `Burger na Satpayeva`
	}
} as ICategory;
